import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
    constructor(private readonly oauthService: OAuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (request.headers.has('OAS')) {
            return next.handle(request);
        }

        const headers: Record<string, string> = {
            'Accept-Language': 'en-GB',
            'Content-Type': request.headers.get('Content-Type') || 'application/json',
            Accept: request.headers.get('Accept') || 'application/json',
        };
        const accessToken = this.oauthService.getAccessToken();
        if (accessToken && !request.headers.has('Authorization')) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }

        return next.handle(request.clone({ setHeaders: headers }));
    }
}
